import React from 'react';
import { ListGroupItem } from 'reactstrap';
import {
    ReportTypes, NEW_REPORT_LABELS, IReportBuilderReport, REPORT_TYPE_LABEL_MAP,
} from 'views/ReportBuilder/constants';
import { NSTable } from 'bricks';

export interface IReportListItemProps {
    report: IReportBuilderReport;
    index: number;
}

const ReportListItem = ({ report, index }: IReportListItemProps) => {
    const { reportType, savedReportName, selectedDocuments } = report;

    switch (reportType) {
        case ReportTypes.DOCUMENT_LIBRARY:
            return (
                <ListGroupItem key={`generate-report-list-${index}`}>
                    <b className="pr-1">{`${index + 1}.`}</b>
                    {NEW_REPORT_LABELS.DOCUMENT_LIBRARY}
                    <div style={{ maxHeight: '250px' }} className="overflow-auto mt-1">
                        <NSTable>
                            <tbody>
                                {selectedDocuments?.map(asset => (
                                    <tr key={asset.id}>
                                        <td className="text-truncate">
                                            <span>{asset.name}</span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </NSTable>
                    </div>
                </ListGroupItem>
            );
        default:
            return (
                <ListGroupItem key={reportType}>
                    <b className="pr-1">{`${index + 1}.`}</b>
                    {savedReportName || REPORT_TYPE_LABEL_MAP[reportType] || reportType}
                </ListGroupItem>
            );
    }
};

export default ReportListItem;
